<template>
  <v-container fluid grid-list-md>
    <v-layout wrap justify-space-between align-center>
      <v-flex xs12>

      <v-form autocomplete="off" @submit.prevent="">
        <v-layout wrap justify-space-between align-center>
          <v-flex xs12 lg4>
            <span class="headline">Comentários</span>
          </v-flex>
          <v-flex xs12 sm6 lg4>
            <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 lg4 class="text-xs-right">
            <v-btn color="primary" @click="create" class="mb-4"  :disabled="task_shared">
              {{this.translate('system.button.add.title')}}
              <v-icon dark> {{this.translate('system.button.add.icon')}}</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-form>
      </v-flex>
      <v-dialog v-model="imageDialog" scrollable>
        <v-card class="mx-auto">
          <v-card-title style="font-weight: bold; font-size: 1.5em;">Visualização de imagem</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-img :src="img.src" contain class="grey darken-4"></v-img>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="mx-0" @click="imageDialog = false">FECHAR</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--Dialog para confirmação de exclusão-->
      <p-confirm text="Tem certeza que deseja excluir o item de " :entity="translate('table.' + entity + '.title')[1]" :dialog="dialogConfirm" @confirm="deleteItem" @cancel="closeDialogDelete"></p-confirm>
      <!--Index-->
      <v-flex xs12>
        <div v-if="filteredComments.length > 0">
          <v-card wrap justify-center align-center v-for="item in filteredComments" :key="item.id" :class="getClassMention(item['mentions'])" style="word-break: break-all;">
            <v-card-title style="padding: 10px" primary-title>
              <div class="body-2" style="font-weight: bold">{{ item.user.id_text + (item.company_id !== task.company_id ? (' ('+item.company.id_text+')') : '')}}</div>
              <pre class="caption" style="color: gray"> - {{item.updated_at | formatDateTime}}</pre>
              <v-menu
                left
                nudge-top="8"
                content-class="elevation-0 menu_content"
                transition="slide-x-reverse-transition"
                :offset-x="true"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn absolute right fab small v-model="fab" slot="activator" v-on="on" icon class="mx-0">
                    <v-icon medium>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-tooltip bottom>
                  <v-btn slot="activator" small color="grey lighten-4" fab class="mx-0" @click="editItem(item)" :disabled="task_shared || item.user_id !== $auth.user().id">
                    <v-icon color="teal">edit</v-icon>
                  </v-btn>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn slot="activator" small color="grey lighten-4" fab class="mx-0" @click="dialogDelete(item)" :disabled="task_shared || (!task.crud_access && item.user_id !== $auth.user().id)">
                    <v-icon color="pink">delete</v-icon>
                  </v-btn>
                  <span>Excluir</span>
                </v-tooltip>
              </v-menu>
            </v-card-title>
            <v-card-text style="padding: 10px">
              <div style="overflow-x: wrap; overflow-wrap: break-word; word-wrap: break-word; hyphens: auto; overflow: auto;" v-html="item.id_text" class="idTextComment"></div>
            </v-card-text>
          </v-card>
        </div>
        <div v-else>
          <v-card class="mb-2">
            <v-card-text style="padding: 10px">
              <p class="text-xs-center">{{emptyTable}}</p>
            </v-card-text>
          </v-card>
        </div>
      </v-flex>
      <!--Create Edit-->
      <v-dialog v-model="dialog" max-width="1200px" persistent scrollable :fullscreen="$vuetify.breakpoint.smAndDown">
        <v-card>
          <v-card-title primary-title style="height: 45px; padding-top: 0px;padding-bottom: 0px;" >
            <span class="headline text-xs-center">{{formTitle}}</span>
            <v-spacer></v-spacer>
            <v-btn v-bind:class="{ [`elevation-${4}`]: true }" v-if="$vuetify.breakpoint.smAndDown" small outline fab color="primary darken-2" @click="addImageComment()"><v-icon>image</v-icon></v-btn>
            <v-btn v-bind:class="{ [`elevation-${4}`]: true }" v-else outline color="primary darken-2" @click="addImageComment()"><v-icon>image</v-icon>INSERIR IMAGEM</v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="padding: 0px;">
            <v-form @keyup.native.esc="modal = false" @keyup.native.ctrl.enter="processSave" id="form_comment">
              <v-container grid-list-md>
                <v-layout wrap justify-center align-center>
                    <p-text-editor ref="editor" @change="(val) => {this.editedItem.id_text = val}"></p-text-editor>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <span v-if="$vuetify.breakpoint.smAndDown"><strong>@</strong> para mencionar</span>
            <span v-else>Digite <strong>@</strong> para mencionar um participante da tarefa</span>
            <v-tooltip bottom v-if="!$vuetify.breakpoint.smAndDown">
              <v-chip slot="activator" style="height:20px;" outline color="primary" @click="$store.commit('dialogBeta/change_values', { text: 'Agora você pode mencionar pessoas pelos comentários.', link: 'https://app.api.illis.com.br/beta/mention.mp4', showDialog: true })" class="beta">
                beta<v-icon>play_arrow</v-icon></v-chip>
              <span>Clique no botão beta para mais informações</span>
            </v-tooltip>

            <v-spacer></v-spacer>
            <v-btn class="mx-0" color="primary darken-2" :loading="loading" @click.native="processSave">Salvar</v-btn>
            <v-btn class="mx-0" :loading="loading" @click.native="close(400)">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<style>
  p {
    margin-bottom: 3px !important;
  }

  hr {
    color: black;
    border-color: black;
    box-sizing: border-box;
    width: 100%;
  }

  pre {
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -o-pre-wrap;
    word-wrap: break-word;
  }

  .speed-dial {
    z-index: 0;
  }

  #editor img {
    width: 250px;
    cursor: zoom-in;
  }

  .idTextComment img {
    max-width: 350px;
    cursor: zoom-in;
  }

  .menu_content {
    padding: 0 10px 10px 10px;
  }

  @media (max-width: 1024px) {
    .idTextComment img {
      max-width: 100%;
    }
  }
</style>

<script>
  import crud from './../../mixin/crud'
  import PConfirm from './../shared/PConfirm'
  import PTextEditor from './../shared/PTextEditor'
  import imageCompress from '../../mixin/imageCompress'
  export default {
    mixins: [crud, imageCompress],
    components: {
      PConfirm, PTextEditor
    },
    data: () => ({
      entity: 'task_comment',
      modal: false,
      id_text: '',
      fab: null,
      search: '',
      imageDialog: false,
      img: ''
    }),
    name: 'Comment',
    props: {
      task: Object,
      task_shared: {
        type: Boolean,
        default: false
      },
      tab: String
    },
    created () {
      this.items = this.task.comments
      this.editedItem = {task_id: this.task.id, id_text: '', mentions: []}
      this.defaultItem = {task_id: this.task.id, id_text: '', mentions: []}
    },
    mounted: function () {
      this.$emit('itemsLength', this.items.length)
      this.addImageListener(document.querySelectorAll('.idTextComment'))
    },
    methods: {
      afterClose () {
        this.$refs.editor.setValue('')
        this.$refs.editor.refresh()
      },
      afterEditItem () {
        this.$refs.editor.setValue(this.editedItem.id_text)
        this.$refs.editor.refresh()
        if (!this.$vuetify.breakpoint.smAndDown) this.$refs.editor.focus(300)
        this.getUsersTask()
      },
      afterCreate () {
        this.$refs.editor.refresh(600)
        this.$refs.editor.focus(600)
        this.getUsersTask()
      },
      getUsersTask () {
        // Carrega todos os usuário que participam da tarefa para serem adicionados nas menções
        this.$http.get(`api/get_users_task/${this.task.id}`).then((res) => {
          let usersTask = res.body
          // implementado o setTimeout para dar tempo depassar os valores para o this.usersTask
          setTimeout(() => { this.$refs.editor.createMention(usersTask) }, 100)
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível buscar os usuários para as menções, reporte o erro.', color: 'error', dialog: true})
        })
      },
      afterSaveValue (newValues) {
        Object.assign(this.editedItem, JSON.parse(JSON.stringify(this.defaultItem)))
        this.items.unshift(newValues)
        this.$emit('itemsLength', this.items.length)
        // shift adicionado para adicionar o registro na primeira linha
        newValues['shift'] = true
        this.$socket.emit('generalDetailsEvent', {
          data: newValues,
          details: 'comments',
          responseEvent: 'addSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
        //! CORREÇÃO DE SET TIME OUT PENDENTE...
        setTimeout(() => {
          this.addImageListener(document.querySelectorAll('.idTextComment'))
        }, 400)
      },
      afterUpdate (res) {
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'comments',
          responseEvent: 'editSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
        setTimeout(() => {
          this.addImageListener(document.querySelectorAll('.idTextComment'))
        }, 400)
      },
      afterDelete (res) {
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'comments',
          responseEvent: 'deleteSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
        this.$emit('itemsLength', this.items.length)
      },
      processSave () {
        this.$store.commit('loader/change_dialog', true)
        this.loading = true
        setTimeout(() => {
          this.editedItem.id_text = this.$refs.editor.getValue()
          // Verifica se tem imagem no id_text pois quando tem apenas imagem o this.$refs.editor.getValueText() vem vazio
          let hasImg = this.editedItem.id_text.includes('<img')
          // Verificar se o comentário está vazio ou não
          if (this.$refs.editor.getValueText().trim() === '' && !hasImg) {
            this.$store.commit('loader/change_dialog', false)
            this.loading = false
            this.$store.commit('snackbar/change_values', {
              text: 'O comentário não pode ser vazio!',
              color: 'warning',
              dialog: true
            })
            return
          }
          // Busca todas as tags com class illis_mention que estão dentro do form_comment(dialog inclusão e edição)
          let mentions = document.getElementById('form_comment').getElementsByClassName('illis_mention')
          this.editedItem['mentions'] = []
          // percorre todas as tag encontradas pois elas possuem os valores dos usuário mencionados
          for (var i = 0; i < mentions.length; i++) {
            let mentionUserId = parseInt(mentions[i].getAttribute('user_id'))
            // verifica se já existe uma menção daquele usuário, se não tiver adiciona
            if (!this.editedItem['mentions'].some((mention) => { return mention === mentionUserId })) {
              this.editedItem['mentions'].push(mentionUserId)
            }
          }
          // convertido o comentario agora para base64 para armazenagem no servido
          this.imgsCompressAndBase64(this.editedItem.id_text).then(res => {
            this.editedItem['id_text'] = res
            this.$store.commit('loader/change_dialog', false)
            this.loading = false
            if (this.view === 2) {
              this.saveValue(this.entity, this.editedItem, this.translate('table.' + this.entity + '.title')[0])
            } else {
              this.save()
            }
          }, err => {
            this.$store.commit('loader/change_dialog', false)
            this.loading = false
            console.log(err)
            this.$store.commit('snackbar/change_values', {
              text: 'Erro ao salvar comentário!',
              color: 'error',
              dialog: true
            })
          })
        }, 500)
      },
      getClassMention (mentions) {
        return (this.$auth.check() && mentions && mentions.some((val) => { return val['user_id'] === this.$auth.user().id })) ? 'mentioned mb-2' : 'mb-2'
      },
      addImageComment () {
        // Sequencia de clicks para fazer o botão que está de fora do comnponente PTEXTEDITOR funcionar, com os mesmos ids dp componente
        document.getElementById('rteObj' + this.$refs.editor.getRandowId() + '_toolbar_Image').click()
        document.getElementById('_insertImage').click()
        // Determina um click no botão de insert a cada 1000 milissegundos, com a intenção de enviar a imagem quando o usuário tiver adicionado-a
        let intevalImgClick = setInterval(function () {
          let insertImage = document.getElementsByClassName('e-insertImage')[0]
          if (insertImage) {
            insertImage.click()
          } else {
            clearInterval(intevalImgClick)
          }
        }, 1000)
      }
    },
    computed: {
      filteredComments () {
        return this.items.filter(item => item.id_text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').match(this.search.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')))
      }
    }
  }
</script>
<style scoped>
 .mentioned {
    /* box-shadow: 0 3px 1px -2px teal, 0 2px 2px 0 teal, 0 1px 5px teal; */
    box-shadow: 0 2px 10px -2px rgb(0 172 193 / 80%), 0 2px 2px 0 rgb(0 172 193 / 80%), 0 1px 5px 0 rgb(0 172 193 / 80%);
    /* text-decoration: none; */
  }
</style>



// WEBPACK FOOTER //
// src/components/details/TaskComment.vue